import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@material-ui/core'
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import AssignmentIcon from '@material-ui/icons/Assignment'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import SendIcon from '@material-ui/icons/Send'
import PedidoCompraSituacao, {
  getPedidoCompraSituacaoLabel,
  normalizePedidoCompraSituacaoExibicao
} from '../../utils/enums/pedidoCompraSituacao'

const BADGE_STYLES = {
  pendente: { backgroundColor: '#f59e0b', color: '#fff' },
  contagem: { backgroundColor: '#0d9488', color: '#fff' },
  enviado: { backgroundColor: '#2563eb', color: '#fff' },
  recebido: { backgroundColor: '#059669', color: '#fff' },
  atendido: { backgroundColor: '#9333ea', color: '#fff' },
  default: { backgroundColor: '#64748b', color: '#fff' }
}

const ICON_STYLE = { color: '#fff', fontSize: 16 }

function resolveBadgeConfig(situacao, numero) {
  const code = normalizePedidoCompraSituacaoExibicao(situacao)

  if (code === PedidoCompraSituacao.RECEBIDO && !numero) {
    return {
      label: getPedidoCompraSituacaoLabel(PedidoCompraSituacao.ENVIADO),
      icon: <SendIcon style={ICON_STYLE} />,
      style: BADGE_STYLES.enviado
    }
  }

  switch (code) {
    case PedidoCompraSituacao.PENDENTE:
      return {
        label: getPedidoCompraSituacaoLabel(PedidoCompraSituacao.PENDENTE),
        icon: <AccessTimeIcon style={ICON_STYLE} />,
        style: BADGE_STYLES.pendente
      }
    case PedidoCompraSituacao.CONTAGEM:
      return {
        label: getPedidoCompraSituacaoLabel(PedidoCompraSituacao.CONTAGEM),
        icon: <AssignmentIcon style={ICON_STYLE} />,
        style: BADGE_STYLES.contagem
      }
    case PedidoCompraSituacao.ENVIADO:
      return {
        label: getPedidoCompraSituacaoLabel(PedidoCompraSituacao.ENVIADO),
        icon: <SendIcon style={ICON_STYLE} />,
        style: BADGE_STYLES.enviado
      }
    case PedidoCompraSituacao.RECEBIDO:
      return {
        label: getPedidoCompraSituacaoLabel(PedidoCompraSituacao.RECEBIDO),
        icon: <LocalShippingIcon style={ICON_STYLE} />,
        style: BADGE_STYLES.recebido
      }
    case PedidoCompraSituacao.ATENDIDO:
      return {
        label: getPedidoCompraSituacaoLabel(PedidoCompraSituacao.ATENDIDO),
        icon: <DoneAllIcon style={ICON_STYLE} />,
        style: BADGE_STYLES.atendido
      }
    default:
      return {
        label: code,
        icon: null,
        style: BADGE_STYLES.default
      }
  }
}

const PedidoCompraSituacaoBadge = ({ situacao, numero, className }) => {
  const { label, icon, style } = resolveBadgeConfig(situacao, numero)

  return (
    <Chip
      className={className}
      icon={icon || undefined}
      label={label}
      size="small"
      style={{
        ...style,
        fontWeight: 600,
        fontSize: 11,
        letterSpacing: 0.4,
        height: 26
      }}
    />
  )
}

PedidoCompraSituacaoBadge.propTypes = {
  situacao: PropTypes.string,
  numero: PropTypes.string,
  className: PropTypes.string
}

export default PedidoCompraSituacaoBadge
